import { render } from "./AndamentoAgenti.vue?vue&type=template&id=70acdf50"
import script from "./AndamentoAgenti.vue?vue&type=script&lang=js"
export * from "./AndamentoAgenti.vue?vue&type=script&lang=js"

import "./AndamentoAgenti.vue?vue&type=style&index=0&id=70acdf50&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__